import { createSelector } from "@reduxjs/toolkit";

export const ownerPortalPropertyState = (state) => state.ownerPortalProperty;

export const ownerPortalPropertySelector = createSelector(ownerPortalPropertyState, (state) => state);
